export const faqs = {
  registered_agent_service: 'https://help.zenbusiness.com/en/collections/8590106-registered-agent-service',
  worry_free_service: 'https://help.zenbusiness.com/en/collections/8590200-worry-free-compliance'
};

export const WEBSITE_TOOLS_BUNDLE_SERVICES = ['website_tools_bundle', 'zb_website_tools_bundle'];

export const WEBSITE_TOOLS_BUNDLE_INCLUDES_ORDER = {
  domain_name_reg: 0,
  domain_name_privacy: 1,
  basic_email: 2,
  static_website: 3
};

export const SERVICE_ACTIVATION_PATH_SUFFIXES = {
  zb_money_pro: '/money/expenses',
  domain_name_reg: '/marketing-tools/domains',
  domain_name_privacy: '/marketing-tools/domains',
  basic_email: '/marketing-tools/emails',
  static_website: '/marketing-tools/websites'
};

export const SERVICE_ACTIVATION_LINK_TEXT = {
  zb_money_pro: 'dashboard.subscriptions.activation.moneyPro',
  domain_name_reg: 'dashboard.subscriptions.activation.domains',
  domain_name_privacy: 'dashboard.subscriptions.activation.domains',
  basic_email: 'dashboard.subscriptions.activation.basicEmail',
  static_website: 'dashboard.subscriptions.activation.businessWebsite'
};
